import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
export function useOrgUpgradeRequestsAllowed({ reason, enabled = true, requireLoadedPolicy = false, }) {
    const { organization, isEnterprise } = useUserOrgData({ reason, enabled });
    const { permissions, isLoaded, isError } = useEffectivePermissions({
        reason,
        enabled: enabled && isEnterprise,
    });
    if (isLoaded && !isError) {
        return permissions.has('org_upgrade_request');
    }
    // Pricing preserves its legacy fallback; direct Computer refusals must not open
    // a request modal while the authoritative policy is unavailable.
    if (requireLoadedPolicy)
        return false;
    return organization?.settings?.allow_member_upgrade_requests ?? true;
}
//# sourceMappingURL=useOrgUpgradeRequestsAllowed.js.map